import React from 'react';
import PropTypes from 'prop-types';
import { StickerLabel, Text } from '@stitch-fix/mode-react';

const StockStatus = ({
  outOfStock,
  inShoppingBag,
  stockMessage,
}: {
  outOfStock: boolean;
  inShoppingBag: boolean;
  stockMessage?: {
    heading?: string | null;
    subheading?: string | null;
  } | null;
}) => {
  let stockStatusText;

  if (outOfStock && inShoppingBag) {
    stockStatusText = 'Sold out';
  } else {
    stockStatusText = stockMessage?.heading;
  }

  return (
    <div data-testid="stock-status">
      {stockStatusText && (
        <StickerLabel variant={outOfStock ? 'error-light' : 'warn'}>
          {stockStatusText}
        </StickerLabel>
      )}
      {stockMessage?.subheading && (
        <Text mt={1} setting="body-xsmall">
          {stockMessage.subheading}
        </Text>
      )}
    </div>
  );
};

StockStatus.propTypes = {
  outOfStock: PropTypes.bool,
  inShoppingBag: PropTypes.bool,
  stockMessage: PropTypes.shape({
    heading: PropTypes.string,
    subheading: PropTypes.string,
  }),
};

StockStatus.defaultProps = {
  outOfStock: false,
  inShoppingBag: false,
  stockMessage: {
    heading: null,
    subheading: null,
  },
};

export default StockStatus;
